import React from 'react';
import '../App.css';
import BGVideo from '../assets/bgvideo.mp4'
import Poster from '../assets/hero-poster.webp'
import {redirectToCalendly} from './Helpers';

export default function Header() {
  return (
    <section className="hero" style={{backgroundImage:`url(${Poster})`}}>
      <video className="hero-video" autoPlay muted loop playsInline poster={Poster} aria-hidden="true">
        <source src={BGVideo} type="video/mp4"/>
      </video>
      <div className="hero-content container">
        <h1>Effortlessly Keep Your Tenants' Electric Vehicles <b>POWERED</b></h1>
        <button type="button" className="btn btn-primary btn-large" onClick={redirectToCalendly}>Book Consultation</button>
        <p className="hero-tagline">Enjoy the Amenity EV Charging Without Hassle Today</p>
      </div>
      <span className="hero-scroll" aria-hidden="true">SCROLL DOWN</span>
    </section>
  )
}
